import React from "react";
// Common Components
import { DynamicMultiSelectDropdown, StaticDropdown } from "src/Components";
// Requests
import { getWalletUsers, getWallets } from "src/Requests/imePortfolio";
// Types
import { IWalletSearchParams, StatusType } from "src/Interfaces/imePortfolio";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";

interface IProps {
  onChange: (name: string, value: any) => void;
  searchParam: IWalletSearchParams;
}

const StatusDropdownOptions: DropdownItem[] = [
  { id: StatusType.Pending, name: "ارسال موفق" },
  { id: StatusType.Successful, name: "موفق" },
  { id: StatusType.Failed, name: "ناموفق" },
];
const SearchParamBox = ({ onChange, searchParam }: IProps) => {
  return (
    <div className="w-full flex flex-row  justify-center items-center gap-2 mb-2">
      <div className="w-48">
        <DynamicMultiSelectDropdown
          dropdown={{
            name: "accountIds",
            placeholder: "اکانت",
            extraLabel: true,
          }}
          getData={getWalletUsers}
          onChange={onChange}
          value={searchParam.accountIds}
        />
      </div>
      <div className="w-48">
        <DynamicMultiSelectDropdown
          dropdown={{
            name: "srcWalletTypes",
            placeholder: "کیف مبدا",
            extraLabel: true,
          }}
          getData={getWallets}
          onChange={onChange}
          value={searchParam.srcWalletTypes}
        />
      </div>
      <div className="w-48">
        <DynamicMultiSelectDropdown
          dropdown={{
            name: "destWalletTypes",
            placeholder: "کیف مقصد",
            extraLabel: true,
          }}
          getData={getWallets}
          onChange={onChange}
          value={searchParam.destWalletTypes}
        />
      </div>
      <div className="w-48">
        <StaticDropdown
          dropdown={{
            name: "status",
            placeholder: "وضعیت",
            extraLabel: true,
          }}
          onChange={onChange}
          options={StatusDropdownOptions}
          value={searchParam.status}
        />
      </div>
    </div>
  );
};

export default SearchParamBox;
